<template>
  <v-container>
    <v-card class="my-3 pa-5">
      <p>Histology Importer</p>
      <v-text-field outlined label="histoDeckId" v-model="histoDeckId"></v-text-field>
      <v-btn @click="buidlHistoContent()">Build Histology Deck</v-btn>

    </v-card>


    <v-card class="my-3 pa-5">
      <p>Path RCAP Importer</p>
      <p>
        Step 1: Log in to Student Consult and Navigate to Path page.
        Select the desired content chapter, then click on another chapter,
        and navigate back to the original chapter. The use the @/rcap/robinsImagesquickGrab.js
         in the console and save the file as "chapter_X.json".
      </p>
      <p>
        Step 2: Use "Download All Images" Chrome Extension to get all images. Upload the images to AWS
        in the /Omentum/rcap/chapter_X folder
      </p>
      <p>
        Step 3: Transform the json file to have the AWS links using the iPython Notebook File src/rcap/set_RCAP_aws_path.ipynb
        MAKE SURE to set the correct chapter name. It will make a chapter_X_p.json fiel whic can be put in the rcap folder.
      </p>
      <p>
        Step 4: Make a new deck in the creator and get the deckId. Make sure to set domain requirement to rcap.bk
      </p>

      <p>
        Step 5: Change the "PathChapter" object in the ContentImporter vue file to the appropriate chapter.
      </p>
      <p>
        Step 6: Paste the deckId in the field below and click "Build Path Deck".
      </p>


      <v-text-field outlined label="pathDeckId" v-model="pathDeckId"></v-text-field>
      <v-btn @click="buildPathDeck()">Build Path Deck</v-btn>

    </v-card>
    <v-card>
      NEURO IMPORTER
      {{keys}}
      <v-btn @click="buildNeuroCards()">Build</v-btn>
      <v-text-field label="deckId" v-model="deckId">



      </v-text-field>
    </v-card>

  </v-container>


</template>
<script>

import firebase from 'firebase'
import NeuroContent from '@/proto/figures.json'

import PathChapter from '@/rcap/chapter_01_p.json'
import HistoContent1 from '@/hwt/SpecialSenses.json'
//import HistoContent2 from '@/hwt/integ2.json'
//import HistoContent3 from '@/hwt/femRp3.json'

import Obj from '@/objects.js'

export default {
  name: 'ContentImporter',
  data() {
    return {
      histoDeckId: null,
      pathDeckId: null,
      deckId: null,
      keys: Object.keys(NeuroContent),
      library: NeuroContent,

    }
  },
  methods: {
    buidlHistoContent() {
      //Set content import above in import section
      var storage = firebase.storage();
      let combined = HistoContent1
      //let combined = HistoContent1.concat(HistoContent2)
      //combined = combined.concat(HistoContent3)
      let urlPromises = []
      combined.forEach(item => {
        if (item.structureImage != null) {
            let image = item.structureImage.split('/').pop()
            try {
              urlPromises.push(storage.refFromURL('gs://omentum-prod.appspot.com/hwtX/' + image).getDownloadURL())
            }
            catch(err) {
              console.log("error image")
            }

        }
        else {
          urlPromises.push(Promise.resolve(null))
        }
      })
      Promise.all(urlPromises).then(imageFirestoreURLs => {
        let batch = firebase.firestore().batch()
        let cardRef = firebase.firestore().collection('cards')

        console.log(imageFirestoreURLs)
        combined.forEach((item, index) => {



          let card = Obj.createNewCard('question_answer')
          card.deck = this.histoDeckId

          if (item.structureImage != null) {
            card.question = "What is depicted?"
            card.question_image = imageFirestoreURLs[index]
            card.answer = item.query
            item.structureText != null ? card.answer += '<p>Structure</p>' + item.structureText : null
            item.function != null ? card.answer += '<p>Function</p>' + item.function : null
          }
          else {
            card.question = item.query
            item.structureText != null ? card.answer += item.structureText : null
            item.function != null ? card.answer += item.function : null
          }
          console.log(card)
          batch.set(cardRef.doc(), card)



        })
        batch.commit()
        console.log("commited edit")
      })





    },
    buildPathDeck() {
      firebase.firestore().collection('decks').doc(this.pathDeckId).get()
      .then(doc => {
        if (doc.exists) {
          return true

        }
        else {
          throw "Error: No Valid Deck Document"
        }
      }).then(() => {
        let batch = firebase.firestore().batch()
        let cardRef = firebase.firestore().collection('cards')

        PathChapter.forEach(entry => {
          let card = Obj.createNewCard('question_answer')
          card.deck = this.pathDeckId
          card.question = "What is shown by the image?"
          card.question_image = entry.src
          card.answer = '<p><b>' + entry.title + '</b></p>' + entry.caption
          batch.set(cardRef.doc(), card)
        })

        batch.commit()
        console.log("commited edit")



      }).catch((err) => {
        console.log(err)
      })

    },

    buildNeuroCards() {
      let result = []
      let importList = ["figure135", "figure137", "figure138"]
      importList.forEach(item => {
        let card = Obj.createNewCard('labeled_image')
        card.deck = this.deckId
        card.image = '/neuro/' + item + '.png'
        card.annotation = '/neuro/' + item + 'd.png'
        card.description = Content[item].desc
        let entries = Content[item].data.split(',')
        entries.forEach(label => {
          card.entries.push({
            label: label.split('.')[0],
            string: label.split('.')[1]
          })

        })
        firebase.firestore().collection('cards').doc().set(card)
        //console.log(card)
      })



    }
  }
/*



  Spinal Sections: Figures 119-124 (Figure 118 with planes)
  Blood Supply: Figures 54-58 (arterial); Figure 68-69 (venous)
  */
}
</script>
